var map = {
	"./404.svg": "8a81",
	"./BECard.svg": "5943",
	"./BELogoUpdated.png": "4017",
	"./BELogoUpdated@2x.png": "4312",
	"./BENewLogos.png": "6f2c",
	"./BENewLogos@2x.png": "f210",
	"./BE_BC_Back.png": "6264",
	"./BE_BC_Back@2x.png": "203f",
	"./BE_BC_Front.png": "4400",
	"./BE_BC_Front@2x.png": "3597",
	"./BE_Mockups.png": "551d",
	"./BE_Mockups@2x.png": "0f8d",
	"./BitfluentCard.svg": "c578",
	"./Bitfluent_Mockups.png": "f3f3",
	"./Bitfluent_Mockups@2x.png": "0103",
	"./KohinoorTelugu-Bold.ttf": "6849",
	"./KohinoorTelugu-Medium.ttf": "85cb",
	"./NSMCard.svg": "7742",
	"./NSM_Mockups.png": "9a78",
	"./NSM_Mockups@2x.png": "7b2c",
	"./WaveSVGMask.svg": "3357",
	"./alert-icon.svg": "b44a",
	"./bitfluentSquareLogo.png": "6f93",
	"./bitfluentSquareLogo@2x.png": "3929",
	"./bottomSwoop.svg": "0adb",
	"./cardIcons/angular.svg": "9e0f",
	"./cardIcons/application.svg": "040b",
	"./cardIcons/browser.svg": "f0cd",
	"./cardIcons/chrome.svg": "61cd",
	"./cardIcons/code.svg": "b3a0",
	"./cardIcons/css3.svg": "f361",
	"./cardIcons/desktop.svg": "6111",
	"./cardIcons/edge.svg": "10ea",
	"./cardIcons/firefox.svg": "1c0b6",
	"./cardIcons/html5.svg": "1042",
	"./cardIcons/javascript.svg": "6781",
	"./cardIcons/mobile.svg": "6512",
	"./cardIcons/mysql.svg": "f14a",
	"./cardIcons/nodejs.svg": "edcf",
	"./cardIcons/react.svg": "3a76",
	"./cardIcons/safari.svg": "8e01",
	"./cardIcons/server.svg": "5aef",
	"./cardIcons/vuejs.svg": "b83a",
	"./coding.svg": "6988",
	"./coding01.svg": "0bae",
	"./designerHero.svg": "4538",
	"./facebook.svg": "aaa3",
	"./headerLogo.svg": "b340",
	"./heroWave.svg": "a92c",
	"./iPhoneHold.svg": "eb43",
	"./instagram.svg": "54e6",
	"./linkedIn.svg": "9e0a",
	"./moneyTransfer.svg": "ecf5",
	"./people.svg": "19b0",
	"./programmingHero.svg": "1e90",
	"./refreshIcon.svg": "ec19",
	"./signInArrow.svg": "cb7f",
	"./theme-moon-icon.svg": "63cf",
	"./theme-sun-icon.svg": "2393",
	"./topSwoop.svg": "caaf",
	"./topSwoopLight.svg": "b77e",
	"./video/BE-Desktop-Video.mp4": "487e",
	"./video/BE-Mobile-Video.mp4": "7ab9",
	"./video/Bitfluent-Desktop-Video.mp4": "699c",
	"./video/Bitfluent-Mobile-Video.mp4": "205f",
	"./video/NSM-Desktop-Video.mp4": "56db",
	"./video/NSM-Mobile-Video.mp4": "78bb",
	"./waveRef.svg": "62ea",
	"./world.svg": "32d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";